import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=7ae4720b&"
import script from "./DateField.vue?vue&type=script&lang=js&"
export * from "./DateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae4720b')) {
      api.createRecord('7ae4720b', component.options)
    } else {
      api.reload('7ae4720b', component.options)
    }
    module.hot.accept("./DateField.vue?vue&type=template&id=7ae4720b&", function () {
      api.rerender('7ae4720b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/DateField.vue"
export default component.exports